import { convert } from '../utils'

let lines = [

  {text: ['在蒙特雷湾水族馆里'],startTime: '00:00:01.00', endTime: '00:00:03.10'},
  {text: ['全是加利“孩”尼亚','热爱跳舞的小家伙们'],startTime: '00:00:03.11', endTime: '00:00:07.21'},
  {text: ['灯光一亮'],startTime: '00:00:07.22', endTime: '00:00:08.23'},
  {text: ['舞会马上开始'],startTime: '00:00:08.24', endTime: '00:00:11.13'},
  {text: ['有跳华尔兹的'],startTime: '00:00:11.14', endTime: '00:00:13.04'},
  {text: ['跳迪斯科的'],startTime: '00:00:13.05', endTime: '00:00:14.16'},
  {text: ['还有跳街舞的'],startTime: '00:00:14.17', endTime: '00:00:16.13'},
  {text: ['到底谁才是这个大舞池里'],startTime: '00:00:16.14', endTime: '00:00:19.12'},
  {text: ['超闪亮的舞者呢'],startTime: '00:00:19.13', endTime: '00:00:21.21'},
  {text: ['你想不想穿上潜水服'],startTime: '00:00:21.22', endTime: '00:00:24.15'},
  {text: ['和它们比一比呢'],startTime: '00:00:24.16', endTime: '00:00:26.12'},

]

export default convert(lines)
